import {Container,Card,Display1,Body1,OutlinedButton} from '@sainsburys-tech/luna-react'
import BackLink from '../../components/BackLink'

const CostaCoffeeMachineInfo = () => {
  return (
    <div>
      <Container size="xs">
        <BackLink linkTo={'/report_problem/enter_asset'} />
        <Card className="ln-c-card ln-u-soft-xl ln-u-border">
        <Display1>
                  <div className="ln-u-padding-ends">Costa Coffee Machine</div>
                </Display1>
            <br />
            <Body1>
             If you experience any issues with your machine, require more or less stock, or need
             additional POS, contact the Costa Express Helpline on 
            </Body1>
            <br />
            <br />
            <OutlinedButton fullWidth>
                01628 537 000.
            </OutlinedButton>
        </Card>
      </Container>
    </div>
  )
}

export default CostaCoffeeMachineInfo